(function ($, Drupal, drupalSettings) {

  Drupal.behaviors.base = {

    attach: function (context, settings) {
    $('.page-node-press_center .abt-lnk a').addClass("main-menu__link--active");
    $('.page-node-article .rsrc-lnk a').addClass("main-menu__link--active");
    $('.page-node-case_studies .rsrc-lnk a').addClass("main-menu__link--active");
    $('.page-node-videos .rsrc-lnk a').addClass("main-menu__link--active");
    $('.page-node-webinar .rsrc-lnk a').addClass("main-menu__link--active");
    $('.page-node-white_paper .rsrc-lnk a').addClass("main-menu__link--active");
      var numItems = $('.views-row').length;
      $("span.rescont").text(numItems);
      var searchval = $('.views-exposed-form #edit-keys').val();
      $('.form-search').val(searchval);
       $.cookie('text1', searchval);
      $('strong.searchres').text($.cookie('text1'));
      $('.filter-chip').hide();
      $('.f-chips, .clr-fltr').remove();
      var f_chips_html = '';
      var f_chips_html1 = '';
      var f_chips_html2 = '';

      // $('.green_menu_clr select').on('change', function(){
      //   alert($('input[id^="edit-keys"]').attr('id'));
      //   });

      $('.views-exposed-form select.form-select').each(function() {
        $('.filter-chip').show();
         if($(this).attr('data-drupal-selector') == "edit-field-topic-target-id") {
          f_chips_html2 = $(this).children("option:selected").text();
          if(f_chips_html2 != 'Filter by Topic'){
          $('.filter-lists').append('<span tabindex="0" class="f-chips" id=' + f_chips_html2 + '>' + f_chips_html2 + '<a href="#removefilter" data-id="edit-field-topic-target-id" title="Remove" class="singlecancle"> X</span></span>');
           }
        }
        if($(this).attr('data-drupal-selector') == "edit-type") {
          f_chips_html = $(this).children("option:selected").text();
          if(f_chips_html != 'Filter by Type'){
          $('.filter-lists').prepend('<span tabindex="0" class="f-chips" id=' + f_chips_html + '>' + f_chips_html + '<a href="#removefilter" data-id="edit-type" title="Remove" class="singlecancle"> X</span></span>');
          }
        }
        if($(this).attr('data-drupal-selector') == "edit-field-audience-target-id") {
          f_chips_html1 = $(this).children("option:selected").text();
          if(f_chips_html1 != 'Filter by Audience'){
          $('.filter-lists').append('<span tabindex="0" class="f-chips" id=' + f_chips_html1 + '>' + f_chips_html1 + '<a href="#removefilter" data-id="edit-field-audience-target-id" title="Remove" class="singlecancle"> X</span></span>');
          }
        }

      });
       var numItems = $('.f-chips').length;
        if(numItems > 0)
        {
          $('.filter-lists').append("<a href='/resources' class='clr-fltr'>Clear All Filters</a>");
        }

      /*resource blk slider*/
      var resrc_sldr_len = $('.resrc-sldr > .view-content .views-row').length;
      $('.resrc-sldr > .view-content').addClass('sldr-cnt-'+resrc_sldr_len);
      if(resrc_sldr_len > 1) {
        $('.resrc-sldr > .view-content').slick({
          dots: true,
          infinite: true,
          autoplay: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
      else {
        $('.resrc-sldr > .view-content').addClass('sldr-wth')
      }

      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object

  /* slick init */
  var hme_sldr_len = $('.field--name-field-home-slider-group .item--paragraph--type--home-content-slider').length;
  if(hme_sldr_len > 1){
      $('.field--name-field-home-slider-group .field--label + .field--items').slick({
      dots: true,
      infinite: true,
      autoplay: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
    });
  }
  else {
    $('.field--name-field-home-slider-group .item--paragraph--type--home-content-slider').addClass('nsldr');
  }


  $('.tstmnl_lnd__blk .field--name-field-members-saycontent').slick({
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });

  $('.tsmnl_sldr .tsmnl-blk > .view-content').slick({
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  /* carrier partner slider */
  $('.carer_prtnr_sldr .field--name-field-partner-and-member-firm.field--items').slick({
    dots: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


      $('.msny-vw-cnt .field--name-field-featured-image, .msny-vw-cnt .field--name-field-card-thumbnail, .msny-vw-cnt .field--name-field-article-front-image').each(function() {
        $(this).css('padding-top', $(this).find('img').attr('height') / $(this).find('img').attr('width') * 100 + '%');
      });



     $('.singlecancle').click(function(){
        $(this).parent().hide();
        var inputid = $(this).attr("data-id");
        $('[data-drupal-selector='+inputid+']').prop('selectedIndex',0);
        $('.bef-exposed-form .form-actions input').trigger("click");
      });


      $('.cls-ico').remove();
      $('.nd-vdo-ovrl').remove();
      $('.field--name-field-resource-video article, .vdo-overly, .vdo-overly-wbnr').append('<div class="cls-ico"><i class="fas fa-times"></i></div>');
      $('.field--name-field-page-contents-paragrpah .node--type-videos, .node--type-videos.node--view-mode-full .plays-videos, .field--name-field-our-team-video .field--name-field-resource-video, .node--type-webinar').append('<div class="nd-vdo-ovrl"></div>');

      /* home page video*/
      $('.paragraph--type-home-videos > .grp-lft').click(function(){
        $(this).closest('.paragraph--type-home-videos').find('video').trigger('play');
        $('body').addClass('vdo-pop-en');
        $(this).closest('.paragraph--type-home-videos').find('.field--name-field-resource-video, .plays-videos').addClass('playvdo');
      });


       $('.cls-ico, .popupbg, .nd-vdo-ovrl').click(function() {
         if($('body').hasClass('vdo-pop-en')) {
          $('.field--name-field-resource-video, .plays-videos').removeClass('playvdo');
          $('.vdo-overly-wbnr').removeClass('plv');
          $('body').removeClass('vdo-pop-en');
           var media =  $(this).closest('.paragraph--type-home-videos').find('video').get(0);
           media.pause();
           media.currentTime = 0;
         }
       });

       /* big video wrap video */
       if($('.sml_cnt_wth_no, .smal_cnt_four, .bg_vd_mdl').hasClass('big_vdo_wrp')) {
          $('.field--name-dynamic-token-fieldparagraph-watch-video-button-paragraph').click(function(){
            $('.paragraph--type-video').addClass('paragraph--type-home-videos');
          $(this).closest('.paragraph--type-video').find('video').trigger('play');

          $('body').addClass('vdo-pop-en');
          $(this).closest('.paragraph--type-video').find('.field--name-field-resource-video, .plays-videos').addClass('playvdo');
        });

      }
      /* node video*/
      $('.field--name-dynamic-token-fieldnode-watch-video-button').click(function(){
        $('video').trigger('play');
        $('.node--type-videos').addClass('paragraph--type-home-videos');
        $('.node--type-webinar .node--type-videos').removeClass('paragraph--type-home-videos');
        $('.node--type-webinar').addClass('paragraph--type-home-videos');
        $('body').addClass('vdo-pop-en');
        $('.plays-videos').addClass('playvdo');
        $('.vdo-overly-wbnr').addClass('plv');
      });

      /* Hide video button if no video. */
      if ($('.field--name-field-featured-image').length === 0 ) {
        $('.field--name-dynamic-token-fieldnode-watch-video-button').hide();
      }

      // Div Hide for no image
      $('.grp-lft').each(function(){
        if($(this).html().trim() == ''){
          $(this).remove();
        }
      });


      /**
       * Sticky Header
      */
      function stk_hdr() {
        var pos = $(window).scrollTop();
        var offset_pre = $('.main').offset().top;
        var offset = $('.main').offset().top+50;
        if(pos > offset_pre) {
          $('body').addClass('fixed-header-start');
        } else {
          $('body').removeClass('fixed-header-start')
        }
        if(pos > offset) {
          $('body').addClass('fixed-header').removeClass('fixed-header_dis');
        } else {
          $('body').removeClass('fixed-header').addClass('fixed-header_dis');
        }
      }

      $(window).on('load', function () {
        $('.msny-vw-cnt').masonry();

        $('body').delay(500).css({
          'overflow': 'visible'
        });
      });
      /**
       * Sticky Header
      */
      $(window).scroll(function() {

        //Sticky Header
        stk_hdr();

      });

      $('.big_vdo_wrp .paragraph--type-video').each(function(){
        var bgImg = $('.big_vdo_wrp .paragraph--type-video img').attr('src');
        $('.big_vdo_wrp').find('.item--paragraph--type--video').css('background-image', 'url('+bgImg+')');
      })

      $('.field--name-field-category-video-title .field--item:first-child').attr('id', 'tab1');
      $('.field--name-field-category-video-title .field--item:nth-child(2)').attr('id', 'tab2');
      $('.field--name-field-category-video-title .field--item:nth-child(3)').attr('id', 'tab3');
      $('.field--name-field-category-video-title .field--item:nth-child(4)').attr('id', 'tab4');
      $('.field--name-field-category-video-title .field--item:nth-child(5)').attr('id', 'tab5');


      $('.ctgy_vdo .item--paragraph--type--home-videos.field--item:first-child').attr('id', 'tab1');
      $('.ctgy_vdo .item--paragraph--type--home-videos.field--item:nth-child(2)').attr('id', 'tab2');
      $('.ctgy_vdo .item--paragraph--type--home-videos.field--item:nth-child(3)').attr('id', 'tab3');
      $('.ctgy_vdo .item--paragraph--type--home-videos.field--item:nth-child(4)').attr('id', 'tab4');
      $('.ctgy_vdo .item--paragraph--type--home-videos.field--item:nth-child(5)').attr('id', 'tab5');

      $('.field--name-field-category-video-title .field--item:first').addClass('current');
      $('.field--name-field-pg-home-videos.field--items .field--item:first').addClass('current');



      $('.field--name-field-category-video-title .field--item').click(function(){
        $(this).siblings('.field--name-field-category-video-title .field--item.current').removeClass("current");
        $(this).addClass("current");
        var index = $(this).index();
        $('.field--name-field-pg-home-videos.field--items .field--item').removeClass('current');
        $('.item--paragraph--type--home-videos.field--item').eq(index).addClass('current');

      });
      $('.src-ovrly').remove();
      $('body').append('<div class="src-ovrly"></div>');

      $('.prct_vrt_sldr .item--paragraph--type--small-content, .prct_mbr_sldr .item--paragraph--type--small-content.field--item').append('<div class="timebar"></div>');
      /*practice vertical slider */
        var sldr_loop;
        (function($) {
          $.fn.seqfx = function(x) {
              var elements = this,
                  l = elements.length,
                  i = x;
              function execute() {
                  $(elements).removeClass('active')
                      var current = $(elements[i]);
                  i = (i + 1) % l;
                  current.addClass('active');
                  sldr_loop = setInterval(function(){
                      $(elements).removeClass('active')
                      var current = $(elements[i]);
                  i = (i + 1) % l;
                  current.addClass('active');

                   }, 4000);
              }
              execute();
              return this;
          } ;
      }($));

      setTimeout(function() {$(".prct_vrt_sldr .item--paragraph--type--small-content").seqfx(0);}, 1000);
      $(".prct_vrt_sldr .item--paragraph--type--small-content").click(function() {
          var index = $(this).index();
          clearInterval(sldr_loop);
          $(".prct_vrt_sldr .item--paragraph--type--small-content").seqfx(index);
        });

        /* game horizontal slider */
        var vsldr_loop;
        (function($) {
          $.fn.vseqfx = function(x) {
              var elements = this,
                  l = elements.length,
                  i = x;
              function execute() {
                  $(elements).removeClass('active')
                      var current = $(elements[i]);
                  i = (i + 1) % l;
                  current.addClass('active');
                  vsldr_loop = setInterval(function(){
                      $(elements).removeClass('active')
                      var current = $(elements[i]);
                  i = (i + 1) % l;
                  current.addClass('active');

                   }, 4000);
              }
              execute();
              return this;
          } ;
      }($));
        $(".prct_mbr_sldr .item--paragraph--type--small-content.field--item").vseqfx(0);
      $(".prct_mbr_sldr .item--paragraph--type--small-content.field--item").click(function() {
          var index = $(this).index();
          clearInterval(vsldr_loop);
          $(".prct_mbr_sldr .item--paragraph--type--small-content.field--item").vseqfx(index);
        });


      /*register close popup remove */
         jQuery(".node-227 .close").click(function(){
           jQuery(".alert.alert-message").hide();

        });

      /* edit class active*/
         $('.userprof p > a').click(function(){
          $(this).toggleClass('btn-act');
         });

      /*search active */
      $('#block-searchform').addClass("src-inr");
      $("#block-searchform").click(function (e) {
        $('#block-searchform').addClass("src-inr");
        $('body').removeClass('srch-active');
      });
      $(".main-menu li.srch-lnk").unbind('click').on("click", function (e) {
        $('body').toggleClass('srch-active');
        if($(window).width() < 919){
          $("#main-nav").removeClass('main-nav--open');
        };
        //$('#toggle-expand').removeClass('toggle-expand--open');
        e.preventDefault();
        if (!$('#block-searchform').hasClass("src-inr")) {
            $('#block-searchform').addClass('src-inr');
        } else {
          $('body').addClass('srch-active');
            $('#block-searchform').removeClass('src-inr');
        }
          if($(window).width() < 919){
              $('.toggle-expand').click(function(){
                $(this).addClass('toggle-expand--open');
                $('body').removeClass('srch-active');
                if($('#main-nav').hasClass('main-nav--open')) {
                  $('#main-nav').addClass('main-nav--open');
                  $(this).parent().find('.toggle-expand').addClass('toggle-expand--open');
                } else {
                  $('#main-nav').removeClass('main-nav--open');
                  $(this).parent().find('.toggle-expand').removeClass('toggle-expand--open');
                }
                if(!$('.srch-active .search-block-form').hasClass('src-inr')){
                  $('.search-block-form').addClass('src-inr');
                } else {
                  $('.search-block-form').removeClass('src-inr');
                }
              });
              $('input.form-search').submit(function() {
                $(this).parent().find('.toggle-expand').addClass('toggle-expand--open');
              });
          }
      });


      $(".form-search").on("click", function (e) {
        e.stopPropagation();
        return false;
      });

      $("#block-searchform").click(function (e) {
        e.stopPropagation();
      });

      $('.src-ovrly').click(function(){
        $('body').removeClass('srch-active');
        $('#block-searchform').addClass('src-inr');
        if($(window).width() < 919){
          $('.toggle-expand').removeClass('toggle-expand--open');
        }
      })

      $(document).on( 'keydown', function ( e ) {
        if ( e.keyCode === 27 ) { // ESC
          $('body').removeClass('srch-active');
          $('#block-searchform').addClass('src-inr');
        }
      });

      $('.field--name-field-page-contents-paragrpah .item--paragraph--type--partners').attr("id","carriers-patner");

      /* menu accessibility */
      // $(document.body).on('focus', '.main-menu > .main-menu__item > a', function(e) {
      //   var el = $(this);
      //   el.closest('.main-menu > .main-menu__item').toggleClass('has-focus');
      //   el.closest('.main-menu > .main-menu__item').attr('data-menuitem', 'true');
      // }).on('blur', '.main-menu  > .main-menu__item > .main-menu > .main-menu--sub-1', function (e) {
      //   var el = $(this);
      //   el.closest('li.main-menu__item').toggleClass('has-focus');
      //   // Only hide sub-menu after a short delay, so links get a chance to catch focus from tabbing
      //   setTimeout(function () {
      //     if (el.siblings('.main-menu__item').attr('data-has-focus') !== 'true') {
      //       el.closest('.main-menu .main-menu__item > li.main-menu__item').attr('data-menuitem', 'false');
      //     }
      //   }, 100);
      // }).on('focusin', '.main-menu > .main-menu--sub-1', function (e) {
      //   var el = $(this);
      //   el.attr('data-has-focus', 'true');
      // }).on('focusout', '.main-menu > .main-menu__item', function (e) {
      //   var el = $(this);
      //   setTimeout(function () {
      //     if (el.find(':focus').length === 0) {
      //       el.attr('data-has-focus', 'false');
      //       if (el.closest('.main-menu > .main-menu__item.has-focus').length === 0) {
      //         el.closest('.main-menu > .main-menu__item').attr('data-menuitem', 'false');
      //       }
      //     }
      //   }, 100);
      // });



      /*faq accessibility */
      $(document.body).on('focusin', '.faq-blk h2', function(e) {
        $(this).closest('.field--item').toggleClass('active');
      })

      // /* masonry start*/
      var presscenter_custom_url = window.location.pathname.split( '/' )[2];
      var resource_custom_url = window.location.pathname.split( '/' )[1];

      if(resource_custom_url === 'resources' || presscenter_custom_url === 'press-center') {
        $('.msny-vw-cnt').masonry({
          // no transitions
          horizontalOrder: true,
          columnWidth: '.masonry-item',
          itemSelector: '.masonry-item',
          fitWidth: true,
          transitionDuration: 0,
        });

      var ht = $('.masonry-layout');

      if($(ht).length == 0){

      /* Custom js code starts */


        // Cached reference to $(window).
        var $window = $(window);

        // The threshold for how far to the bottom you should reach before reloading.
        var scrollThreshold = 200;

        // The selector for the automatic pager.
        var automaticPagerSelector = '[data-drupal-views-infinite-scroll-pager="automatic"]';

        // The selector for both manual load and automatic pager.
        var pagerSelector = '[data-drupal-views-infinite-scroll-pager]';

        // The selector for the automatic pager.
        var contentWrapperSelector = '[data-drupal-views-infinite-scroll-content-wrapper]';

        // The event and namespace that is bound to window for automatic scrolling.
        var scrollEvent = 'scroll.views_infinite_scroll';

        /**
         * Insert a views infinite scroll view into the document.
         *
         * @param {jQuery} $newView
         *   New content detached from the DOM.
         */
        $.fn.infiniteScrollInsertView = function ($newView) {
          // Extract the view DOM ID from the view classes.
          var matches = /(js-view-dom-id-\w+)/.exec(this.attr('class'));
          var currentViewId = matches[1].replace('js-view-dom-id-', 'views_dom_id:');

          // Get the existing ajaxViews object.
          var view = Drupal.views.instances[currentViewId];
          // Remove once so that the exposed form and pager are processed on
          // behavior attach.
          view.$view.removeOnce('ajax-pager');
          view.$exposed_form.removeOnce('exposed-form');
          // Make sure infinite scroll can be reinitialized.
          var $existingPager = view.$view.find(pagerSelector);
          $existingPager.removeOnce('infinite-scroll');

          //var $newRows = $newView.find(contentWrapperSelector).children();
          //var $newPager = $newView.find('.js-pager__items');

          /***patch content */

            // Check if masonry is involved
        if (view.$view[0].querySelector('.msny-vw-cnt')) {
            // get only .views-row as new rows
            var $newRows = $newView.find(contentWrapperSelector).find('.views-row');
            // Add the new rows to existing view.
            view.$view.find('.msny-vw-cnt').append($newRows).masonry( 'appended', $newRows, true );
          }
          else {
            // get all children of contentWrapperSelector as new rows
            var $newRows = $newView.find(contentWrapperSelector).children();
            // Add the new rows to existing view.
            view.$view.find('.msny-vw-cnt').append($newRows).masonry( 'appended', $newRows, true );
          }

          // Add the new rows to existing view.
          //view.$view.find(contentWrapperSelector).append($newRows);
          var $newPager = $newView.find('.js-pager__items');
          // Replace the pager link with the new link and ajaxPageState values.
          $existingPager.replaceWith($newPager);

          // Run views and VIS behaviors.
          Drupal.attachBehaviors(view.$view[0]);
        };

        /**
         * Handle the automatic paging based on the scroll amount.
         *
         * @type {Drupal~behavior}
         *
         * @prop {Drupal~behaviorAttach} attach
         *   Initialize infinite scroll pagers and bind the scroll event.
         * @prop {Drupal~behaviorDetach} detach
         *   During `unload` remove the scroll event binding.
         */
        Drupal.behaviors.views_infinite_scroll_automatic = {
          attach : function(context, settings) {
            $(context).find(automaticPagerSelector).once('infinite-scroll').each(function() {
              var $pager = $(this);
              $pager.addClass('visually-hidden');
              $window.on(scrollEvent, debounce(function() {
                if (window.innerHeight + window.pageYOffset > $pager.offset().top - scrollThreshold) {
                  $pager.find('[rel=next]').click();
                  $window.off(scrollEvent);
                }
              }, 200));
            });
          },
          detach: function (context, settings, trigger) {
            // In the case where the view is removed from the document, remove it's
            // events. This is important in the case a view being refreshed for a reason
            // other than a scroll. AJAX filters are a good example of the event needing
            // to be destroyed earlier than above.
            if (trigger === 'unload') {
              if ($(context).find(automaticPagerSelector).removeOnce('infinite-scroll').length) {
                $window.off(scrollEvent);
              }
            }
          }
        };
        }
      }
      /* masonry scroll end */
    }


  }

  $(document).ready(function(){
    // $('.prct_vrt_sldr .item--paragraph--type--small-content, .prct_mbr_sldr .item--paragraph--type--small-content.field--item').append('<div class="timebar"></div>');

    $('.rltd-vd').appendTo('.big_vdo_wrp .item--paragraph--type--video .paragraph--type-video');

    $('.tit_am .field--name-node-title a').each(function() {
      var old_html = $(this).html();
      $(this).html(old_html.replace(/ /g, '<br/>'));
    });

    $('.rltd-vd .views-row').each(function() {
      if(!$(this).find('.views-field-title').length) {
        $(this).remove();
      }
    });
    $('.msny-vw-cnt').masonry();
    $(window).resize(function() {
      $('.msny-vw-cnt').masonry();
    })
  });



  // Redirecting the url

  $('.tsmnl_hm_blk .more-link a').click(function () {
    var oldUrl = $(this).attr("href");
    var newUrl = oldUrl.replace(oldUrl,"/resources?type=case_studies");
    $(this).attr("href", newUrl);
  });

  $(function() {
    var span = $('<div />').attr({'class':'folder_name' }).html('');
    $('.password-parent label').after(span);
  });


/* Resource Back Button*/
(function($) {
  var filter_by_type = document.querySelector('#edit-type');
})(jQuery);
/* Resource Back Button*/





  // if(Drupal.settings.user_js_uid != "")
  // {
  //   alert("sdfsdf");
  //   $(".grp-lft").click(function(){
  //     $(".grp-lft").removeClass("reg-lnk");
  //   });
  // }

//   Drupal.behaviors.ifCE = { //the name of our behavior
//     attach: function (context, settings) {
//     var userUID = settings.user.uid;
//     if(userUID == 0)
//     {
//       $(".big_vdo_wrp .item--paragraph--type--video .grp-lft").click(function(e){
//         $("body").addClass("register_active");
//         $('.main-nav').removeClass('main-nav--open');
//         $('.toggle-expand').removeClass('toggle-expand--open');
//         return false;
//       });
//     }
//   }
// }
// var value = $('#edit-keys .form-text .form-item__textfield').val();
// var value = $("#edit-keys").find(".form-text").val();
// $(this).val( $(this).attr("placeholder") );
// alert();
// $('.view-header').prepend($('<span>' +value+ '</span>'));



})(jQuery, Drupal, drupalSettings);

